<div class="add-70">
    <div class="full-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
            <h2 class="font-600 text-center">
                The Future of Your Management is Simple
            </h2>
        </div>
    
        <div class="down-arrow">
            <img src="assets/img/drop_down.svg" alt="">
        </div>
    </div>
</div>


<div class="page-section">
    <app-client-marquee></app-client-marquee>
</div>

<div class="page-section">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="font-600">My Inside Story</h2>
            </div>
            <div class="col-12">
                <p>Hi There!</p>
                <p>I am NuvertOS, and I'm proud to say that I was born as an action. My story began in 2015, when an engineer-turned-entrepreneur used technology and innovation to tackle a major healthcare management problem involving hospitals and clinics of all kinds. That's where my foundation was established.</p>
                <p>At the start of my journey, I had just a single prescription module. However, today I have grown into a comprehensive healthcare management system, with more than 35 different SaaS modules automating multiple healthcare processes.</p>
                <p>Hospitals, clinics, pharmacies, and labs workflow were all streamlined by my creation of One system to manage all. Specialized processes that are part of our offering allow the system to be configured and customized to the user's demands.</p>
                <p>And let me tell you, it hasn't been easy. My expertise, accumulated over more than a decade in the HealthTech industry, has helped me understand the challenges faced by hospitals, clinics, pharmacies, and labs in managing their workflows. And with my tireless dedication and ingenuity, I've managed to streamlined and digitize healthcare.</p>
                <p>Now, hospitals, clinics, pharmacies, and labs use my system to manage workflows. And I've even customized it to their specific needs! I'm like a healthcare superhero, swooping in and saving the day with my top-notch software.</p>
                <p>So if you ever find yourself in a hospital or clinic, know that NuvertOS is behind the scenes, ensuring everything runs smoothly. And who knows, maybe one day I'll even have my own action figure!</p>
                <p>So if you want to be a part of the future of healthcare, just call me and I am happy to serve you.</p>
            </div>
        </div>

        <div class="row align-items-center flex-wrap h-100 usp-row">
            <div class="col-6">
                <h3 class="font-700">Vision</h3>
                <p>I envision a world where simplicity replaces complexity. I strongly believe that upgrading to simplicity can transform the way we work, enhance productivity, and drive success.</p>
            </div>
            <div class="col-6">
                <img src="assets/img/vision.svg" alt="image" class="usp-image">
            </div>
        </div>

        <div class="row align-items-center flex-wrap h-100 usp-row">
            <div class="col-6">
                <img src="assets/img/mission.svg" alt="image" class="usp-image">
            </div>
            <div class="col-6 text-right">
                <h3 class="font-700">Mission</h3>
                <p>Simplifying complex processes is my mission. I provide individuals and businesses with the tools they need to simplify their lives and achieve management goals.</p>
            </div>
        </div>

        <div class="row align-items-center flex-wrap h-100 mt-5">
            <div class="col-12 text-center">
                <h3 class="font-600">Our Leaders</h3>
            </div>
            <div class="col-lg-4 col-12">
                <div class="leader-image">
                    <img src="assets/img/people/nitin.jpg" alt="Nitin Gupta, Chief executive officer">
                </div>

                <div class="text-center">
                    <p class="employee-name">Nitin Gupta</p>
                    <p class="employee-designation">Chief executive officer</p>
                </div>
            </div>
            <div class="col-lg-4 col-12">
                <div class="leader-image">
                    <img src="assets/img/people/abhishek.jpg" alt="Abhishek Kashpyap, Chief technology Officer">
                </div>

                <div class="text-center">
                    <p class="employee-name">Abhishek Kashyap</p>
                    <p class="employee-designation">chief technology officer</p>
                </div>
            </div>
            <div class="col-lg-4 col-12">
                <div class="leader-image">
                    <img src="assets/img/people/rahul.jpg" alt="Rahul Tyagi, Chief Operating Officer">
                </div>

                <div class="text-center">
                    <p class="employee-name">Rahul Tyagi</p>
                    <p class="employee-designation">Chief Operations Officer</p>
                </div>
            </div>
        </div>

        <div class="row align-items-center flex-wrap h-100 mt-5">
            <div class="col-12 text-center">
                <h3 class="font-600">
                    Our Pillars
                </h3>
            </div>

            <div class="col-12">
                <div class="row pillars-row">
                    <ng-container *ngFor="let pillar of pillars">
                        <div class="col-12 col-sm-6 col-lg pillar-card text-center">
                            <div class="pillar-image">
                                <img [src]="pillar.img" [alt]="pillar.name">
                            </div>
            
                            <div class="text-center">
                                <p class="employee-name">{{pillar.name}}</p>
                                <p class="employee-designation">{{pillar.designation}}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>


    </div>
</div>

<div class="career-card">
    <div class="container">
        <div class="row align-items-center flex-wrap h-100">
            <div class="col-md-6">
                <h2 class="font-600">
                    Interested in joining the Team?
                </h2>
                <br>
                <button type="button" routerLink="/careers" class="btn brand-button">Explore Careers</button>
            </div>
            <div class="col-md-6">
                <img src="assets/img/explore_career.svg" alt="" width="400rem">
            </div>
        </div>
    </div>
</div>

<div class="page-section">
    <div class="container">
        <div class="row">
            <div class="col-2">
                <h2 class="font-600">What the FAQ?</h2>
            </div>
            <div class="col-12">
                <ng-container *ngFor="let faq of faqs">
                    <div class="card mb-3"  (click)="collapse.toggle()" [attr.aria-expanded]="faq.colalpse" aria-controls="collapseExample">
                        <div class="card-body">
                            <p class="font-600 faq-header" style="margin-bottom: 0">{{faq.question}}
                            <span class="collapse-marker" [ngClass]="{'rotate-marker': !faq.collapse}"></span>
                            </p>
                            <div #collapse="ngbCollapse" [(ngbCollapse)]="faq.collapse">
                                <div style="margin-top: 1rem">{{faq.answer}}</div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <br>
        </div>
    </div>
</div>

<app-contact-card></app-contact-card>

